import styled from 'styled-components';

const Column = styled.div<any>`
  display: flex;
  flex-direction: column;
  ${({ width = '50%' }) => {
    return `width: ${width}`;
  }};
`;

export default Column;
